// do not use imports in this file!! we are trying to keep lead form bundle js clean

import {getCommonVisualizerType, IS_STAGING} from "../../../../../config";
import {getCurrentLayout} from "../../../../appLayout";
import {checkIfLookFeaturesReceived, getFeatureFromTheBackendBySku} from "../../../../../api/look-api";
import {pruneWizardItemGraph} from "./wizardLoadBypassGroups";
import {loaderDisable, loaderEnable} from "../../../../ui/loaderView";

export const fixStringEncoding = (string) => {
  return string && (typeof string === "string")
    ? string
      .replace("â€�", "”")
      .replace("â€", "”")
      .replace("â€™", "’")
      .replace("â€¨", " ")
      .replace("Ã¢â‚¬Â¨", "") // not sure what it is
    : string
}

// // remove node
// export const fixWizardItemFromMissingNodes = (wizardItem) => {
//   const {
//     wizardNodes = [],
//     wizardEdges = [],
//     wizardGroups = [],
//     // removedEdges = [],
//     // removedGroups = [],
//   } = wizardItem;
//
//   const validNodeIds = new Set(wizardNodes.map(node => node.id));
//
//   const fixedWizardEdges = wizardEdges.filter(edge =>
//     validNodeIds.has(edge.target)
//   );
//
//   const fixedWizardGroups = wizardGroups.filter(group =>
//     validNodeIds.has(group.id)
//   );
//
//   return {
//     ...wizardItem,
//     wizardEdges: fixedWizardEdges,
//     wizardGroups: fixedWizardGroups,
//     // removedEdges: mergedRemovedEdges,
//     // removedGroups: mergedRemovedWizardGroups,
//   };
// };

export const fixWizardItem = (wizardItem, wizardItemIndex, forLeadForm = false, newVisualizerType) => {
  // wizardItem = fixWizardItemFromMissingNodes(wizardItem);
  wizardItem.wizardNodes = []; // we don't use them in the visualizer! why do we keep them then
  Object.keys(wizardItem).forEach(property => {
    if (typeof wizardItem[property] === "string") {
      wizardItem[property] = fixStringEncoding(wizardItem[property]);
    }
  });
  if (!wizardItem.name) {
    wizardItem.name = "wizard" + (wizardItemIndex > 0 ? "-" + wizardItemIndex + 1 : "");
  }
  const currentVisType = getCommonVisualizerType(newVisualizerType);

  wizardItem = pruneWizardItemGraph(wizardItem, currentVisType);

  if (wizardItem.wizardGroups) {
    wizardItem.wizardGroups = wizardItem.wizardGroups.map(wizGroup => {
      if (forLeadForm) {
        //getUrlLeadStepName
        wizGroup.leadStepUrl = wizGroup.leadStep
          ? wizGroup.leadStep.toLowerCase().replace(/ /g,"-")
          : "project"
      }
      if (wizGroup.nodeType === "inputs" && Array.isArray(wizGroup.inputFields)) {
        wizGroup.inputFields = wizGroup.inputFields.filter(inputObject => inputObject.checked)
      }
      if (IS_STAGING && (wizGroup.groupName === "Vanitie")) {
        wizGroup.groupName = "Vanity"
      }
      Object.keys(wizGroup).forEach(property => {
        if (typeof wizGroup[property] === "string") {
          wizGroup[property] = fixStringEncoding(wizGroup[property]);
        }
      });
      ["featuresIncluded", "featuresExcluded"].forEach(property => {
        if (Array.isArray(wizGroup[property]) && wizGroup[property].length) {
          wizGroup[property] = wizGroup[property].map(excluded => {
            if (excluded && (typeof excluded === "object") && excluded.sharedFeatureName) {
              excluded.sharedFeatureName = excluded.sharedFeatureName
                .trim()
                .toLowerCase()
                .replace('room - ', '')
            }
            return excluded
          })
        }
      });
      return wizGroup
    })
  }
  return wizardItem
}

const findWizardFeatureFromNavItems = (layout, featureGroup, nameToCompare) => {
  const navItems = layout.designNavigationItems({part: featureGroup}, null, "", false, "all");
  for (let i = 0; i < navItems.length; i++) {
    if (navItems[i].part.getLowerCasedSharedFeatureName() === nameToCompare) {
      return navItems[i].part;
    }
  }
  return null
}

export const getWizardFeatureAsync = async (feature, groupName) => {
  const layout = getCurrentLayout();
  const featureGroup = layout.getFeatureGroupByGroupName(groupName);
  if (featureGroup) {
    const nameToCompare = feature.sharedFeatureName; //lowercased already
    if (featureGroup.activeFeature && featureGroup.activeFeature.getLowerCasedSharedFeatureName() === nameToCompare) {
      return featureGroup.activeFeature
    }
    let found = findWizardFeatureFromNavItems(layout, featureGroup, nameToCompare);
    if (found) {
      return found
    }
    if (featureGroup && !featureGroup.allFeaturesReceived && !featureGroup.requestInProgress) {
      loaderEnable();
      await checkIfLookFeaturesReceived(featureGroup);
      loaderDisable();
    }
    found = findWizardFeatureFromNavItems(layout, featureGroup, nameToCompare);
    if (found) {
      return found
    }
    const roomFeaturesArray = featureGroup.features; // here we search among all features if it was found, because
    // we can have Shower Size 48" and we are looking for 60" Replacement Tub or Walk In Tub
    if (Array.isArray(roomFeaturesArray)) {
      for (let i = 0; i < roomFeaturesArray.length; i++) {
        if (roomFeaturesArray[i].getLowerCasedSharedFeatureName() === nameToCompare) {
          return roomFeaturesArray[i]
        }
      }
    }
  }
  return await getFeatureFromTheBackendBySku(feature.sku || feature.sharedFeatureName, featureGroup ? featureGroup.partId : "");
}
